const menuItems = [
  {
    id: 'agenda',
    title: 'Agenda',
    icon: 'calendar-alt',
    path: '/agenda'
  },
  {
    id: 'clients',
    title: 'Clientes',
    icon: 'users',
    path: '/clients'
  },
  {
    id: 'staff',
    title: 'Profissionais',
    icon: 'users-cog',
    path: '/staff'
  },
  {
    id: 'services',
    title: 'Serviços',
    icon: 'cut',
    path: '/services'
  },
  {
    id: 'products',
    title: 'Produtos',
    icon: 'spray-can',
    path: '/products'
  },
  {
    id: 'reports',
    title: 'Relatórios',
    icon: 'file-invoice-dollar',
    path: '/reports'
  }
];

export default menuItems;
